import { CategoryOfFixedAssetService } from "./../../../services/catalogs/CategoryOfFixedAssetService";
import { CreateCategoryOfFixedAssetDto } from "../../../dtos/catalogs/CategoryOfFixedAsset/CreateCategoryOfFixedAssetDto";
import React from "react";
import { CategoryOfFixedAssetDetail } from "../../../components/Pages/Catalogs/Category of Fixed Assets/CategoryOfFixedAssetDetail";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCategoryOfFixedAsset } from "../../../components/Shared/NewForms/NFLookupCategoryOfFixedAsset";
import CategoryOfFixedAssetList from "../../../components/Pages/Catalogs/Category of Fixed Assets/CategoryOfFixedAssetList";

export const CategoryOfFixedAsset: IAppEntity = {
  entityType: "catalog",
  title: "Category Of Fixed Asset",
  pluralTitle: "Category Of Fixed Assets",
  apiUrl: "CategoryOfFixedAssets",
  apiEnum: ReferenceTypes.CatalogCategoryOfFixedAssets,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CategoryOfFixedAssetDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CategoryOfFixedAssetList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCategoryOfFixedAsset, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new CategoryOfFixedAssetService(this.apiUrl);
  },
  getEmptyModel(): CreateCategoryOfFixedAssetDto {
    return {
      name: "",
    };
  },
};
